export default "https://cdn-shared.mathletics.com/teacher-modules/mathletics-library/38/assets/images/loading.0c238a17d7497a0852e1dfd0a0fd7e00.gif";